import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-brand-cream text-brand-dark py-24 px-6" data-id="element-161">
      <div className="max-w-3xl mx-auto text-center" data-id="element-162">
        <FadeIn data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-green" data-id="element-164">
            Estás trabajando duro.
          </h2>
          <div className="space-y-6 text-lg md:text-xl leading-relaxed font-light text-brand-dark/80" data-id="element-165">
            <p data-id="element-166">
              Sigues los consejos de inversión, lees sobre negocios y te
              esfuerzas por escalar tus ingresos. Pero, por dentro, algo no
              encaja.
            </p>
            <p data-id="element-167">
              Sientes una fatiga que el café ya no puede ocultar. Te acuestas
              con la mente acelerada y te despiertas con una presión en el
              pecho.
            </p>
            <p className="font-medium text-brand-dark text-xl md:text-2xl mt-8 italic" data-id="element-168">
              Has caído en la trampa moderna: creer que para ganar libertad
              financiera, primero debes perder tu vida.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}